import React, {lazy} from 'react';
import ReactDOM from 'react-dom/client';
import './assets/scss/General.scss';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import ScrollToTop from "./Components/ScrollToTop";
import WhatsappFloat from "./Components/WhatsappFloat";

const  Empresas = lazy(() => import("./pages/Empresas"));
const App =  lazy(() =>  import( './App'));
const FullBlog = lazy(()=> import ("./pages/FullBlog"))
const LegalIndexPage = lazy(() => import("./pages/Legales/LegalIndexPage"));
const LegalDocumentPage = lazy(() => import("./pages/Legales/LegalDocumentPage"));
const Cobertura = lazy(() => import("./pages/Cobertura"));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <BrowserRouter>
          <ScrollToTop />
          <WhatsappFloat />
          <Routes>
              <Route path="/" element={<App />} />
              <Route path="/Empresas" element={<Empresas />} />
              <Route path="/blog/:IdBlog" element={<FullBlog/>}/>
              <Route path="/legales" element={<LegalIndexPage/>}/>
              <Route path="/legales/:slug" element={<LegalDocumentPage/>}/>
              <Route path="/cobertura" element={<Cobertura/>}/>
          </Routes>
      </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
